import React from 'react';

import mail from '@/public/assets/mail.png';
import mail2x from '@/public/assets/mail@2x.png';
import mail3x from '@/public/assets/mail@3x.png';
import ImgIcon from '../BaseIcon';

const Mail = () => (
    <ImgIcon
        srcset={`${mail},
                ${mail2x} 2x,
                ${mail3x} 3x,`}
        src={mail3x}
        alt="mail"
    />
);

export default Mail;
